import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Mutation } from 'react-apollo';
import queryString from 'query-string';

import Input from '../../components/Form/Input';
import { Button } from '../../components/Button';
import gql from 'graphql-tag';
import { ErrorMessage } from '../../components/Form/styles';
import { loginUserAction } from '../../actions/loginUser';
import { pick } from 'lodash';
import { EMAIL_VALIDATION_REGEXP } from '../../constants/validationRegexp';

function validate(values) {
  const errors = {};

  if (values.email && !EMAIL_VALIDATION_REGEXP.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (!values.email) {
    errors.email = 'Required';
  }

  if (values.password && values.password.length < 6) {
    errors.password = 'Password must be at least 6 characters long';
  }

  if (!/[0-9]/.test(values.password)) {
    errors.password = 'Password must contain at least one digit';
  }

  if (!/[a-z]/.test(values.password)) {
    errors.password = 'Password must contain at least one lowercase letter (a-z)!';
  }

  if (!/[A-Z]/.test(values.password)) {
    errors.password = 'Password must contain at least one uppercase letter (A-Z)!';
  }

  if (!values.password) {
    errors.password = 'Required';
  }

  return errors;
}

export const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  padding: 0 15px;
  background-color: #e9faff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;

  .loginContainer {
    position: relative;
    padding-top: 30px;

    h2 {
      font-weight: 300;

      b {
        font-weight: 600;
      }
    }
  }
`;

export const ForgotLink = styled.p`
  margin-top: 20px;
  font-size: 15px;
  line-height: 1.4;
  color: #999999;

  @media (min-width: 992px) {
    margin-top: 45px;
  }

  a {
    font-size: 15px;
    line-height: 1.4;
    color: #4272d7;
    cursor: pointer;
    text-decoration: none;
  }
`;

export const SubmitButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
  padding: 22px 15px;
  background-color: #4272d7;
  color: #fff;
  transition: all 0.4s ease;

  &:hover {
    background-color: #333333;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;

    &:hover {
      background-color: #4272d7;
    }
  }
`;

const LoginSwitcher = styled.ul`
  width: 100%;
  margin: 25px 0;
  display: flex;

  li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    min-width: 50%;
    padding: 15px;
    background-color: #e2e2e2;
    font-size: 24px;
    cursor: pointer;

    &.active {
      background-color: rgba(66, 114, 215, 0.91);
      color: white;
    }
  }
`;

const loginUser = gql`
  mutation loginUser($email: String!, $password: String!) {
    loginUser(email: $email, password: $password) {
      id
      name
      email
      image
      phone
      role
      countries {
        id
        name
        iso2
        iso3
        flag
      }
      availableRoles {
        role
        roleLabel
      }
      roles {
        role
        region {
          id
          name
          isGlobalRegion
        }
      }
      socialLinks {
        facebook
        linkedin
        twitter
      }
      availableRoles {
        role
      }
      authorization
      workspaceId
      competitions {
        owners {
          name
        }
      }
    }
  }
`;

const loginNominee = gql`
  mutation loginNominee($email: String!, $password: String!) {
    loginNominee(email: $email, password: $password) {
      id
      name
      role
      status
      webSite
      email
      authorization
      typeForms
      editable
      uploadedFiles {
        profilePicture {
          link
          title
        }
      }
      socialLinks {
        facebook
        linkedin
        twitter
      }
      categories {
        id
        name
        typeForms {
          id
        }
      }
      competition {
        region {
          id
          name
        }
        owners {
          name
        }
      }
    }
  }
`;

class Login extends Component {
  constructor(props) {
    super(props);
    const query = queryString.parse(props.location.search);

    props.initialize(pick(query, ['email']));

    this.state = {
      loginSwitcher: 'nominee'
    };
  }

  submitForm = (e, mutation) => {
    mutation({ variables: { email: e.email, password: e.password } });
  };

  loginSwitcher = (data) => {
    this.setState({ loginSwitcher: data });
  };

  loginTitle = () => {
    const { loginSwitcher } = this.state;

    switch (loginSwitcher) {
      case 'nominee':
        return 'Nominee';
      case 'user':
        return 'User';
      default:
        return 'Nominee';
    }
  };

  onComplete = (data) => {
    const { history, loginUserAction } = this.props;
    const { loginSwitcher } = this.state;
    const loginMutationName = loginSwitcher === 'user' ? 'loginUser' : 'loginNominee';

    loginUserAction(data[loginMutationName]);
    history.replace('/');
  };

  render() {
    const { handleSubmit, submitting } = this.props;
    const { loginSwitcher } = this.state;
    const isUserTab = loginSwitcher === 'user';
    const loginMutation = isUserTab ? loginUser : loginNominee;

    return (
      <LoginContainer>
        <div className="loginBox loginContainer">
          <h2>
            <b>Login as</b>{' '}
          </h2>
          <LoginSwitcher>
            <li
              className={loginSwitcher === 'nominee' ? 'active' : ''}
              onClick={() => this.loginSwitcher('nominee')}
            >
              <span>Nominee</span>
            </li>
            <li
              className={loginSwitcher === 'user' ? 'active' : ''}
              onClick={() => this.loginSwitcher('user')}
            >
              <span>Admin</span>
            </li>
          </LoginSwitcher>

          <Mutation mutation={loginMutation} onCompleted={this.onComplete}>
            {(loginMutationName, { error }) => {
              return (
                <div>
                  <form onSubmit={handleSubmit((e) => this.submitForm(e, loginMutationName))}>
                    <Field name="email" component={Input} type="email" placeholder="Email" />
                    <Field
                      name="password"
                      component={Input}
                      type="password"
                      placeholder="Password"
                    />
                    <SubmitButton disabled={submitting}>Login</SubmitButton>
                    <div>
                      {error &&
                        error.graphQLErrors.map(({ message }, i) => (
                          <ErrorMessage key={i}>{message}</ErrorMessage>
                        ))}
                    </div>
                  </form>
                </div>
              );
            }}
          </Mutation>
          <ForgotLink>
            Forgot <Link to={`/reset-password?nomination=${!isUserTab}`}>Password?</Link>
          </ForgotLink>
        </div>
      </LoginContainer>
    );
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginUserAction
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(
  reduxForm({
    form: 'login',
    validate
  })(Login)
);
